
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index196LyrRG3RfraqhhJ_ZgxgsMuhKeBB81e8wCSG4x0fkMeta } from "C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/index.vue?macro=true";
import { default as loginEVo8Dw0mekQ0QHmooT_45NG6Phmq0ID9J_45Yy_IjMOSoDoMeta } from "C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/login.vue?macro=true";
import { default as registerHfzgOiiAY2B8gvNQjQUdoCcisVprODUUFFXWlSo0bhcMeta } from "C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/register.vue?macro=true";
import { default as indexC_rbaLoH15a_me7Zhw9EEPRmWPPKmHF1fU2k_45OJ3_45UEMeta } from "C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/app/index.vue?macro=true";
import { default as _91id_93zYxn078u4UxM_45EYJx8czUSJfg6_45YDFiiwZ6h4OevdvgMeta } from "C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/app/halo/[id].vue?macro=true";
import { default as reset_45passwordotgMCiNkY4BfbMcr1wjAkMD7RXRblp687NNDYft6vsIMeta } from "C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/reset-password.vue?macro=true";
import { default as forgot_45password_zXqbHoNmK7GTYU3LZ458m6ClsYnfmfrIFYl5muhoNoMeta } from "C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/forgot-password.vue?macro=true";
import { default as email_45verificationoMGtvYsbeNGUYw_A4vcv62i283Q2xC_6PHyNXweUkGgMeta } from "C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/email-verification.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index196LyrRG3RfraqhhJ_ZgxgsMuhKeBB81e8wCSG4x0fkMeta || {},
    component: () => import("C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginEVo8Dw0mekQ0QHmooT_45NG6Phmq0ID9J_45Yy_IjMOSoDoMeta || {},
    component: () => import("C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/login.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerHfzgOiiAY2B8gvNQjQUdoCcisVprODUUFFXWlSo0bhcMeta || {},
    component: () => import("C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/register.vue")
  },
  {
    name: "app",
    path: "/app",
    meta: indexC_rbaLoH15a_me7Zhw9EEPRmWPPKmHF1fU2k_45OJ3_45UEMeta || {},
    component: () => import("C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/app/index.vue")
  },
  {
    name: "app-halo-id",
    path: "/app/halo/:id()",
    meta: _91id_93zYxn078u4UxM_45EYJx8czUSJfg6_45YDFiiwZ6h4OevdvgMeta || {},
    component: () => import("C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/app/halo/[id].vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/reset-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/forgot-password.vue")
  },
  {
    name: "email-verification",
    path: "/email-verification",
    component: () => import("C:/Users/main8/Desktop/halomind/halomind-nuxt/pages/email-verification.vue")
  }
]